import { Document, Image, Page, Text, View } from '@react-pdf/renderer';
import { ICourse } from 'src/models';
import certificateImg from 'src/assets/images/certificate2.png';
import styles from './CertificatePdf-styles';

interface Props {
	name: string;
	courseName: string;
	institutionName: string;
	department: string;
	duration: string;
	qualification: number;
	date: string;
	showPosition?: boolean;
	showInstitution?: boolean;
}

function CertificatePDF({
	courseName,
	date,
	department,
	duration,
	institutionName,
	name,
	qualification,
	showInstitution,
	showPosition,
}: Props) {
	return (
		<Document>
			<Page
				object-fit={'fill'}
				orientation={'landscape'}
				size={'A4'}
				style={styles.page}
			>
				<View style={styles.view}>
					<Image src={certificateImg} style={styles.image} />

					<View style={styles.dateContainer}>
						<Text style={styles.date}> {date} </Text>
					</View>

					<Text style={styles.name}> {name.toUpperCase()} </Text>

					<View style={styles.institutionContainer}>
						{showInstitution && (
							<Text style={styles.institutionName}>
								{' '}
								{institutionName}{' '}
							</Text>
						)}

						{showPosition && (
							<View style={styles.departmentContainer}>
								<Text style={styles.department}>
									{' '}
									{department}{' '}
								</Text>
							</View>
						)}
					</View>

					<View style={styles.courseContainer}>
						<Text style={styles.courseName}>
							{' '}
							&quot;{courseName}&quot;{' '}
						</Text>

						<View style={styles.courseDataContainer}>
							<Text style={styles.time}>
								{' '}
								{duration}, Calificación: {qualification}{' '}
							</Text>
						</View>
					</View>
				</View>
			</Page>
		</Document>
	);
}

export default CertificatePDF;
